import { CircleAlert, Check, User } from "lucide-react";
import { DEBRIEF_CARD } from "@/data/landingContent";

const READY_VALUE = 3;

type DebriefCardProps = {
  compact?: boolean;
};

export const DebriefCard = ({ compact = false }: DebriefCardProps) => {
  return (
    <article className="landing-card rounded-[20px] border border-neutral-200 bg-white p-6 md:p-8">
      <h2 className="text-lg font-bold text-neutral-900 md:text-xl">{DEBRIEF_CARD.title}</h2>

      <ul className="mt-6 space-y-4">
        <li className="flex items-start gap-3">
          <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-blue-50 text-blue-600">
            <Check className="h-3.5 w-3.5" strokeWidth={2.5} />
          </span>
          <div className="text-[15px] leading-snug">
            <p className="text-neutral-500">{DEBRIEF_CARD.handledLabel}</p>
            <p className="font-medium text-neutral-900">{DEBRIEF_CARD.handled}</p>
          </div>
        </li>
        <li className="flex items-start gap-3">
          <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-orange-50 text-orange-700">
            <CircleAlert className="h-3.5 w-3.5" strokeWidth={2.5} />
          </span>
          <div className="text-[15px] leading-snug">
            <p className="text-neutral-500">{DEBRIEF_CARD.stuckLabel}</p>
            <p className="font-medium text-orange-700">{DEBRIEF_CARD.stuck}</p>
          </div>
        </li>
      </ul>

      {!compact && (
        <div className="mt-7">
          <p className="text-[15px] font-medium text-neutral-900">{DEBRIEF_CARD.confidence}</p>
          <div className="mt-4" role="img" aria-label="3 de 5">
            <div className="relative h-2">
              <div className="absolute inset-x-0 top-1/2 h-[3px] -translate-y-1/2 rounded-full bg-neutral-200" />
              <div
                className="absolute top-1/2 h-[3px] -translate-y-1/2 rounded-full bg-blue-500"
                style={{ width: `${((READY_VALUE - 1) / 4) * 100}%` }}
              />
              <div className="relative flex justify-between">
                {[1, 2, 3, 4, 5].map((step) => (
                  <span
                    key={step}
                    className={`block h-3.5 w-3.5 rounded-full border-2 ${
                      step <= READY_VALUE
                        ? "border-blue-500 bg-blue-500"
                        : "border-neutral-200 bg-white"
                    } ${step === READY_VALUE ? "h-4 w-4 -mt-0.5" : ""}`}
                  />
                ))}
              </div>
            </div>
            <div className="mt-2 flex justify-between text-xs text-neutral-500">
              {[1, 2, 3, 4, 5].map((step) => (
                <span key={step} className="w-3.5 text-center">
                  {step}
                </span>
              ))}
            </div>
          </div>
        </div>
      )}

      <div className="mt-7 flex items-center gap-3">
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-blue-50 text-blue-600">
          <User className="h-4 w-4" strokeWidth={2} />
        </span>
        <p className="text-[15px] text-neutral-900">{DEBRIEF_CARD.coach}</p>
      </div>
    </article>
  );
};
